import { render } from "./signInByFaceRecognition.vue?vue&type=template&id=1e64dd5a&scoped=true"
import script from "./signInByFaceRecognition.vue?vue&type=script&lang=js"
export * from "./signInByFaceRecognition.vue?vue&type=script&lang=js"

import "@/css/view.css?vue&type=style&index=0&id=1e64dd5a&scoped=true&lang=css"
import "@/css/information.css?vue&type=style&index=1&id=1e64dd5a&scoped=true&lang=css"
import "./signInByFaceRecognition.vue?vue&type=style&index=2&id=1e64dd5a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mr.Wu\\Desktop\\Files\\XiHe\\code\\xihe_levelexam_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e64dd5a"]])

export default __exports__